import { graphql } from '../../gql';

export const GET_ALL_QUOTE_EDITIONS = graphql(`
  query getAllQuoteEditions($token: String!, $quoteUuid: String!) {
    getAllQuoteEditions(token: $token, quoteUuid: $quoteUuid) {
      id
      uniqueID
      friendlyId
    }
  }
`);
